import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { ExperimentVariation } from './ExperimentVariation';

export const mapStateToProps = state => ({
  query: state.request.query,
});

export const ExperimentVariationContainer = decorateWith(
  connect(mapStateToProps),
  withName('ExperimentVariationContainer')
)(ExperimentVariation);
